export const GET_FABRIC_TRADING_RESOURCE = "GET_FABRIC_TRADING_RESOURCE"
export const GET_FABRIC_TRADING_RESOURCE_SUCCESS =
  "GET_FABRIC_TRADING_RESOURCE_SUCCESS"
export const GET_FABRIC_TRADING_RESOURCE_ERROR =
  "GET_FABRIC_TRADING_RESOURCE_ERROR"

export const GET_FABRIC_TRADING_LIST_RESOURCE =
  "GET_FABRIC_TRADING_LIST_RESOURCE"
export const GET_FABRIC_TRADING_LIST_RESOURCE_SUCCESS =
  "GET_FABRIC_TRADING_LIST_RESOURCE_SUCCESS"
export const GET_FABRIC_TRADING_LIST_RESOURCE_ERROR =
  "GET_FABRIC_TRADING_LIST_RESOURCE_ERROR"
